import { ROUTE_DASHBOARD } from '@/constants/routes';

/**
 * Validate redirect URL to prevent open redirect attacks.
 * Only allows relative paths starting with /.
 *
 * @param redirect - The redirect URL to validate
 * @returns A safe redirect path or the dashboard as fallback
 */
export function getSafeRedirect(redirect: string | null | undefined): string {
  if (!redirect) return ROUTE_DASHBOARD;

  // Must start with /
  if (!redirect.startsWith('/')) return ROUTE_DASHBOARD;

  // Reject protocol-relative URLs (//evil.com)
  if (redirect.startsWith('//')) return ROUTE_DASHBOARD;

  // Reject any URL with protocol
  if (redirect.includes('://')) return ROUTE_DASHBOARD;

  return redirect;
}
